export default "__VITE_ASSET__HSITPeDO__"